import Backend from '@/api/backend'

const BoolTypes = [
  {
    value: false,
    label: '否'
  },
  {
    value: true,
    label: '是'
  }
]

const UserGenderList = [
  {
    value: 0,
    label: '男'
  },
  {
    value: 1,
    label: '女'
  },
  {
    value: 2,
    label: '未知'
  }
]

const numericTypes = [
  {
    value: 1,
    label: '数值型'
  },
  {
    value: 2,
    label: '列表型'
  }
]

const devicePurpose = [
  {
    value: 1,
    label: '试用'
  },
  {
    value: 2,
    label: '借用'
  },
  {
    value: 3,
    label: '出售'
  }
]

const roles = [
  {
    label: '超级管理员',
    value: 0
  },
  {
    label: '系统管理员',
    value: 1
  },
  {
    label: '市场人员',
    value: 2
  },
  {
    label: '研发人员',
    value: 3
  },
  {
    label: '售后管理员',
    value: 4
  },
  {
    label: '售后工程师',
    value: 5
  }
]

const SoftWareList = [
  {
    label: '软件',
    value: 1
  },
  {
    label: '硬件',
    value: 2
  }
]

const WarnLevelList = [
  {
    label: '级别1',
    value: 1
  },
  {
    label: '级别2',
    value: 2
  },
  {
    label: '级别3',
    value: 3
  }
]

const WarnStatuList = [
  {
    label: '开始告警',
    value: 1
  },
  {
    label: '无需处理',
    value: 2
  },
  {
    label: '处理完成',
    value: 3
  }
]

const MessageSendStatuList = [
  {
    label: '已发送, 待确认',
    value: 1
  },
  {
    label: '成功',
    value: 2
  },
  {
    label: '失败',
    value: 3
  }
]

const TaskStatuList = [
  {
    label: '已创建',
    value: 1
  },
  {
    label: '处理中',
    value: 2
  },
  {
    label: '处理完成',
    value: 3
  }
]

const DeviceTypes = {
  1: '扫描仪',
  2: '制片机',
  3: 'AI服务器'
}

const DateTypes = {
  NOW_WEEK: {
    label: '本周',
    value: 1
  },
  NOW_MONTH: {
    label: '本月',
    value: 2
  },
  DATE: {
    label: '日报',
    value: 3
  },
  MONTH: {
    label: '月报',
    value: 4
  },
  YEAR: {
    label: '年报',
    value: 5
  }
}

const virtuals = [
  {
    name: '机器',
    value: 1
  },
  {
    name: '平台',
    value: 0
  }
]

const moduleLogList = [
  {
    text: '权限管理',
    child: [{
      text: '客户管理',
      operation: ['增加客户', '编辑客户', '删除客户']
    }, {
      text: '供应商管理',
      operation: ['增加供应商', '编辑供应商', '删除供应商']
    }, {
      text: '用户管理',
      operation: ['增加用户', '编辑用户', '删除用户', '重置密码']
    }, {
      text: '角色管理',
      operation: ['新增角色', '分配权限', '编辑角色', '删除角色']
    }
    //  {
    //   text: '经销商管理',
    //   operation: ['添加经销商', '编辑经销商', '经销商制片机业务分析']
    // }, {
    //   text: '代理商管理',
    //   operation: ['添加代理商', '编辑代理商', '删除代理商', '代理商制片机业务分析']
    // }
    ]
  },
  {
    text: '设备管理',
    child: [{
      text: '设备列表',
      operation: ['增加设备', '编辑设备', '删除设备', '转移设备', '升级', '下发参数', '下载许可证', '更改故障处理人']
    }, {
      text: '参数列表',
      operation: ['新增设备型号', '编辑设备型号', '删除设备型号', '一键导入参数', '新增参数', '编辑参数', '删除参数']
    }]
  },
  {
    text: '报警管理',
    child: [{
      text: '报警设置',
      operation: ['新增报警', '编辑报警', '删除报警']
    }]
  },
  {
    text: '任务管理',
    child: [{
      text: '任务列表',
      operation: ['保存任务', '转发任务', '完成任务']
    }]
  },
  {
    text: '版本管理',
    child: [{
      text: '版本列表',
      operation: ['新增版本', '作废版本']
    }]
  }
]
// const serverTypes = [
//   {
//     label: 'AI设备web服务',
//     value: 101
//   },
//   {
//     label: 'AI设备java服务',
//     value: 102
//   },
//   {
//     label: 'AI设备监控服务',
//     value: 103
//   },
//   {
//     label: 'AI设备java服务配置文件',
//     value: 104
//   },
//   {
//     label: 'AI设备ftp服务',
//     value: 105
//   }
// ]

function getServerVersion (callSource, id) {
  const items = []
  Backend.post(callSource, 'version_manage/get_server_list', { type_id: id }).then(data => {
    items.push(...data.items)
  })
  return items
}

export default {
  BoolTypes,
  UserGenderList,
  SoftWareList,
  WarnLevelList,
  WarnStatuList,
  TaskStatuList,
  moduleLogList,
  DeviceTypes,
  DateTypes,
  virtuals,
  MessageSendStatuList,
  numericTypes,
  devicePurpose,
  roles,
  getServerVersion
}
